(() => {
  'use strict';
  function init(root) {
    root.querySelectorAll('[data-photo-slideshow]').forEach(gallery => {
      if (gallery.dataset.bound) return;
      gallery.dataset.bound = 'true';
      const slides = Array.from(gallery.querySelectorAll('[data-slide]'));
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, inView = false, hovering = false, focused = false, timer;
      const schedule = () => {
        clearTimeout(timer);
        if (inView && !hovering && !focused && !document.hidden && !reduced.matches) {
          timer = setTimeout(() => show(index + 1, false), 5000);
        }
      };
      const show = (next, manual = true) => {
        gallery.dataset.transitioned = 'true';
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== index; slide.classList.toggle('is-current', i === index); });
        gallery.querySelector('[data-gallery-count]').textContent = `${index + 1} / ${slides.length}`;
        if (manual) gallery.querySelector('[data-gallery-status]').textContent = `Photo ${index + 1} of ${slides.length}`;
        schedule();
      };
      gallery.querySelector('[data-gallery-controls]').hidden = false;
      gallery.querySelector('[data-gallery-prev]').addEventListener('click', () => show(index - 1));
      gallery.querySelector('[data-gallery-next]').addEventListener('click', () => show(index + 1));
      gallery.addEventListener('mouseenter', () => { hovering = true; schedule(); });
      gallery.addEventListener('mouseleave', () => { hovering = false; schedule(); });
      gallery.addEventListener('focusin', () => { focused = true; schedule(); });
      gallery.addEventListener('focusout', event => { if (!gallery.contains(event.relatedTarget)) { focused = false; schedule(); } });
      document.addEventListener('visibilitychange', schedule);
      reduced.addEventListener('change', schedule);
      const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; schedule(); }, { threshold: 0.15 });
      observer.observe(gallery);
      const unload = event => {
        if (!event.target.contains(gallery)) return;
        clearTimeout(timer); observer.disconnect();
        reduced.removeEventListener('change', schedule);
        document.removeEventListener('visibilitychange', schedule);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
